import { SelectOption } from '~/types';
import { formatReportingPeriod } from '.';

export const getReportingPeriodOptions = (value: number): SelectOption<string>[] => {
    const dropdownOptions: SelectOption<string>[] = [];
    for (let i = value; i >= 1; i--) {
        dropdownOptions.push({
            label: `${formatReportingPeriod(i)}${i === value ? ' (max)' : ''}`,
            value: i.toString(),
        });
    }
    return dropdownOptions;
};
